// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Ou68","content":"LoadingAlert_content__2Ke_X"};